import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Newspaper, LineChart, Bell } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function useLaunchStatus() {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/public/launch-status").then(({ data }) => setSt(data)).catch(() => {}); }, []);
  return st;
}

export function LaunchBanner() {
  const st = useLaunchStatus();
  if (!st?.teaser_mode) return null;
  return (
    <div className="bg-bb-gold/10 border-y border-bb-gold/30 text-center px-5 py-2.5" data-testid="launch-banner">
      <span className="text-bb-champagne text-xs tracking-wide">
        The Provenance news desk is live now · Full platform launches <span className="text-bb-gold font-semibold">August 28, 2026</span> · Founding memberships open
      </span>
    </div>
  );
}

export function NotifyMe() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/public/notify-launch", { email });
      setDone(true);
      toast.success(data.message);
    } catch { toast.error("Please enter a valid email"); }
  };
  if (done) return <p className="text-bb-success text-xs mt-6" data-testid="notify-done">You're on the launch list. See you August 28.</p>;
  return (
    <form onSubmit={submit} className="flex items-center justify-center gap-2 mt-8" data-testid="notify-form">
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
        data-testid="notify-email"
        className="bg-transparent border border-bb-line focus:border-bb-gold outline-none rounded-sm px-3.5 py-2.5 text-sm w-56 placeholder:text-bb-dim" />
      <button type="submit" data-testid="notify-submit"
        className="border border-bb-gold text-bb-gold hover:bg-bb-gold hover:text-white transition-colors rounded-sm px-4 py-2.5 text-[0.62rem] uppercase tracking-[0.12em] inline-flex items-center gap-1.5">
        <Bell size={11} /> Notify me at launch
      </button>
    </form>
  );
}

export function TeaserGate() {
  const nav = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="teaser-gate">
      <div className="max-w-xl text-center px-6 py-14">
        <CalendarClock size={28} className="text-bb-gold mx-auto mb-5" />
        <div className="text-[0.62rem] uppercase tracking-[0.28em] text-bb-gold mb-3">Pre-Launch Access</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight">August 28, 2026</h1>
        <p className="text-bb-muted text-sm leading-relaxed mt-4">
          The full Virtus intelligence terminal — Virtus Trade, FX signals, the Yield Desk, price indices and the
          African Markets Desk — opens on launch day. Your account is registered and access activates automatically.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          <button onClick={() => nav("/pricing")} data-testid="teaser-founding-cta"
            className="bg-bb-gold text-bb-bg hover:bg-bb-champagne transition-colors rounded-sm px-5 py-2.5 text-xs font-semibold uppercase tracking-wide">
            Become a Founding Member
          </button>
          <button onClick={() => nav("/wire")} data-testid="teaser-news-link"
            className="border border-bb-gold/50 text-bb-champagne hover:bg-bb-gold/10 transition-colors rounded-sm px-5 py-2.5 text-xs uppercase tracking-wide inline-flex items-center gap-2">
            <Newspaper size={13} /> Read The Provenance
          </button>
          <button onClick={() => nav("/africa-fx")} data-testid="teaser-fx-link"
            className="border border-bb-gold/50 text-bb-champagne hover:bg-bb-gold/10 transition-colors rounded-sm px-5 py-2.5 text-xs uppercase tracking-wide inline-flex items-center gap-2">
            <LineChart size={13} /> African FX Board
          </button>
        </div>
        <NotifyMe />
        <button onClick={() => nav("/login")} data-testid="teaser-signin-link"
          className="mt-6 text-bb-gold text-[0.7rem] uppercase tracking-[0.14em] underline underline-offset-4 hover:text-bb-champagne transition-colors">
          Member or owner? Sign in to open your dashboard →
        </button>
      </div>
    </div>
  );
}
